import React, { Component } from "react";
import axios from 'axios';
import config from "src/config/config";
import { getHeader } from "../../../utils/api";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Backdrop from '@material-ui/core/Backdrop';
import Loading from 'src/components/Loading';
import styles from './index.module.scss';

class CompanyChanger extends Component {

    state = {
        companies: [],
        open: false,
        search: '',
        switching: false
    };

    activeItemRef = React.createRef();

    componentDidMount() {
        let h = getHeader();
        let headers = {};
        for (let entry of h.entries()) {
            headers[entry[0]] = entry[1];
        }
        axios.request({
            method: "GET",
            url: config.apiEndpoint + "companyAdmin/superadmin/companies",
            headers: headers
        }).then((response) => {
            if (response.data.data && response.data.data.companies && response.data.data.companies.length > 0) {
                this.setState({ companies: response.data.data.companies });
            }
        });
    }

    openModal = () => this.setState({ open: true, search: '' }, () => {
        setTimeout(() => {
            if (this.activeItemRef.current) {
                this.activeItemRef.current.scrollIntoView({ block: 'center' });
            }
        }, 50);
    });

    closeModal = () => this.setState({ open: false, search: '' });

    selectCompany = (unid) => {
        this.setState({ open: false, search: '', switching: true });
        let h = getHeader();
        let headers = {};
        for (let entry of h.entries()) {
            headers[entry[0]] = entry[1];
        }
        axios.request({
            method: "POST",
            data: { companyUnid: unid },
            url: config.apiEndpoint + "companyAdmin/superadmin",
            headers: headers
        }).then((response) => {
            if (response.data.success === 0) {
                window.location.reload(false);
            }
        });
    };

    render() {
        const { companies, open, search, switching } = this.state;
        const { dataAccountInfo } = this.props;

        if (companies.length <= 0 || !dataAccountInfo.account) {
            return null;
        }

        const currentCompany = dataAccountInfo.account.company;
        const filtered = companies.filter(c =>
            c.name.toLowerCase().includes(search.toLowerCase())
        );

        return (
            <div style={{ paddingTop: '10px', paddingBottom: '50px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span>Viewing Company:</span>
                <span style={{ fontWeight: 700 }}>{currentCompany.name}</span>
                <Button
                    color="primary"
                    size="small"
                    onClick={this.openModal}
                    style={{ marginLeft: '2px', textDecoration: 'underline', minWidth: 0, padding: '0 4px' }}
                >
                    Change
                </Button>

                <Backdrop open={switching} style={{ zIndex: 1400 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Loading style={{ position: 'static', background: 'transparent', height: 'auto', width: 'auto' }} />
                        <span style={{ color: '#fff', fontSize: '15px' }}>Switching company...</span>
                    </div>
                </Backdrop>

                <Dialog open={open} onClose={this.closeModal} fullWidth maxWidth="sm">
                    <div className={styles.dialogTitle}>
                        <span>Select Company</span>
                        <IconButton size="small" onClick={this.closeModal}>
                            <span className="mdi mdi-close" style={{ fontSize: '20px' }} />
                        </IconButton>
                    </div>

                    <DialogContent>
                        <div className={styles.searchWrap}>
                            <Input
                                fullWidth
                                autoFocus
                                placeholder="Search company..."
                                value={search}
                                onChange={e => this.setState({ search: e.target.value })}
                                disableUnderline={false}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <span className={`mdi mdi-magnify ${styles.searchIcon}`} />
                                    </InputAdornment>
                                }
                            />
                        </div>

                        <div className={styles.list}>
                            {filtered.length === 0 ? (
                                <div className={styles.emptyText}>No companies found</div>
                            ) : filtered.map((company) => {
                                const isActive = String(company.unid) === String(currentCompany.unid);
                                return (
                                    <div
                                        key={company.unid}
                                        ref={isActive ? this.activeItemRef : null}
                                        className={`${styles.companyItem} ${isActive ? styles.active : ''}`}
                                        onClick={() => this.selectCompany(company.unid)}
                                    >
                                        <div className={styles.companyAvatar}>
                                            {company.name.charAt(0)}
                                        </div>
                                        <span className={`${styles.companyName} ${isActive ? styles.active : ''}`}>
                                            {company.name}
                                        </span>
                                        {isActive && (
                                            <span className={styles.activeBadge}>Current</span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }

}

export default CompanyChanger;
